export default "__VITE_ASSET__DJHuKvpN__"